import { render, staticRenderFns } from "./PeopleMap.vue?vue&type=template&id=73a5d374&scoped=true"
import script from "./PeopleMap.vue?vue&type=script&lang=js"
export * from "./PeopleMap.vue?vue&type=script&lang=js"
import style0 from "./PeopleMap.vue?vue&type=style&index=0&id=73a5d374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5d374",
  null
  
)

export default component.exports